import {useEffect, useRef, useState} from 'react';
import {useSearchParams} from 'react-router-dom';

import IPagination from '../../api/model/IPagination';
import {getPage} from '../filterHelper';

const RESET_DELAY_MS = 100;

const useResetPageOnEmpty = <T, >(pagination?: IPagination<T>): boolean => {
    const [searchParams, setSearchParams] = useSearchParams();
    const [isRedirecting, setIsRedirecting] = useState(false);
    const timerRef = useRef<ReturnType<typeof setTimeout>>();

    useEffect(() => () => clearTimeout(timerRef.current), []);

    useEffect(() => {
        if (!pagination || pagination.items?.length !== 0) {
            return;
        }

        const urlPage = getPage(searchParams);

        if (pagination.currentPage > 1 || urlPage > 1) {
            // eslint-disable-next-line react-hooks/set-state-in-effect
            setIsRedirecting(true);
            searchParams.set('page', '1');
            setSearchParams(searchParams);
            clearTimeout(timerRef.current);
            timerRef.current = setTimeout(() => setIsRedirecting(false), RESET_DELAY_MS);
        }
    }, [pagination, searchParams, setSearchParams]);

    return isRedirecting;
};

export default useResetPageOnEmpty;
